<template>
    <section class="container relative">
        <div
            :style="isTablet ? `perspective: 1500px` : ''"
            :class="
                isTablet
                    ? 'grid grid-cols-1 grid-rows-2 gap-5 md:grid-cols-2 md:grid-rows-3 xl:grid-cols-3 xl:grid-rows-2'
                    : 'space-y-2 sm:space-y-5'
            ">
            <OurAdvantagesCard
                :gradient="cards[config.public.website][0].gradientDirection"
                class="max-md:h-[11.25rem] md:col-span-2">
                <Component
                    :is="cards[config.public.website][0].icon"
                    class="absolute -bottom-6 right-0 max-md:h-auto max-md:w-[16rem] md:-bottom-24"></Component>
                <h2
                    v-html="cards[config.public.website][0].title"
                    class="relative text-32/100 font-semibold md:text-48/100"></h2>
            </OurAdvantagesCard>
            <template v-if="isTablet">
                <OurAdvantagesCard
                    v-for="item in cards[config.public.website].slice(1, 5)"
                    :key="item.title"
                    :gradient="item.gradientDirection">
                    <Component
                        :is="item.icon"
                        class="size-10 md:size-20" />
                    <div class="mt-3 md:mt-10">
                        <h3
                            v-html="item.title"
                            class="text-16/120 font-semibold text-ash-200 md:text-24/133"></h3>
                        <p
                            v-html="item.description"
                            class="mt-2 text-16/148 font-medium text-accent-100 md:mt-5"></p>
                    </div>
                </OurAdvantagesCard>
            </template>
            <div
                v-else
                class="mt-2 block max-w-full">
                <div class="swiper swiper-advantages">
                    <div class="swiper-wrapper items-stretch">
                        <div
                            v-for="item in cards[config.public.website].slice(
                                1,
                                5
                            )"
                            :key="item.title"
                            class="swiper-slide !h-auto !w-[17.5rem]">
                            <div class="swiper-slide__inner h-full">
                                <OurAdvantagesCard
                                    :gradient="item.gradientDirection">
                                    <Component
                                        :is="item.icon"
                                        class="size-10 md:size-20" />
                                    <div class="mt-3 md:mt-10">
                                        <h3
                                            v-html="item.title"
                                            class="text-16/120 font-semibold text-ash-200 md:text-24/133"></h3>
                                        <div
                                            v-html="item.description"
                                            class="mt-2 text-16/148 font-medium text-accent-100 md:mt-5"></div>
                                    </div>
                                </OurAdvantagesCard>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { Swiper } from 'swiper'
import type { TGradientType } from '~/types/global.types'

import OurAdvantagesCard from '~/components/particles/our-advantages/OurAdvantagesCard.vue'
import GearIcon from '~/components/particles/our-advantages/svg/GearIcon.vue'
import HeartIcon from '~/components/particles/our-advantages/svg/HeartIcon.vue'
import LogoIcon from '~/components/particles/our-advantages/svg/LogoIcon.vue'
import StarIcon from '~/components/particles/our-advantages/svg/StarIcon.vue'
import WrenchIcon from '~/components/particles/our-advantages/svg/WrenchIcon.vue'

interface IOurAdvantagesCard {
    icon: Component
    title: string
    gradientDirection: TGradientType
    description: string
}

const config = useRuntimeConfig()
//todo: вынести
const cards: { [key: string]: IOurAdvantagesCard[] } = {
    'cromi.ru': [
        {
            icon: LogoIcon,
            title: 'Мы&nbsp;&mdash; фанаты<br />своего дела',
            gradientDirection: 'top-left',
            description: '',
        },
        {
            icon: GearIcon,
            title: 'Глубокая экспертность в&nbsp;сфере',
            gradientDirection: 'top-right',
            description:
                'Директор компании&nbsp;&mdash; дипломированный инженер аудио-визуальной техники, коммерческий директор&nbsp;&mdash; лингвист и&nbsp;переводчик. Мы&nbsp;используем свой профессиональный опыт, чтобы предлагать рынку наиболее надежные, качественные и&nbsp;удобные технические решения.',
        },
        {
            icon: HeartIcon,
            title: 'Внимание к&nbsp;деталям',
            gradientDirection: 'bottom',
            description:
                'Cromi для нас&nbsp;&mdash; возможность реализовать весь инженерный и&nbsp;управленческий потенциал. Остались работать только в&nbsp;сферах, в&nbsp;которых имеем 100% экспертность. В&nbsp;менеджменте балансируем между европейской чёткостью и&nbsp;русской душевностью.',
        },
        {
            icon: StarIcon,
            title: 'Инновации и&nbsp;прогрессивность',
            gradientDirection: 'left',
            description:
                'Ежегодно посещаем крупнейшие отраслевые выставки ISE в&nbsp;Барселоне и&nbsp;Prolight &amp;&nbsp;Sound во&nbsp;Франкфурте&nbsp;&mdash; следим за&nbsp;последними тенденциями рынка и&nbsp;перенимаем лучшие решения европейских производителей.',
        },
        {
            icon: WrenchIcon,
            title: 'Комфорт и&nbsp;удобство',
            gradientDirection: 'bottom-right',
            description:
                'Прежде чем начать производить и&nbsp;импортировать оборудование, мы&nbsp;много лет сами работали в&nbsp;прокате подобных систем. Поэтому каждый товар, который мы&nbsp;продаём был создан или отобран по&nbsp;принципу удобства реальной эксплуатации и&nbsp;надежности.',
        },
    ],
    'cromi.rent': [
        {
            icon: LogoIcon,
            title: 'Мы&nbsp;&mdash; фанаты<br />своего дела',
            gradientDirection: 'top-left',
            description: '',
        },
        {
            icon: GearIcon,
            title: 'Глубокая экспертность в&nbsp;сфере',
            gradientDirection: 'top-right',
            description:
                'Директор компании&nbsp;&mdash; дипломированный инженер аудио-визуальной техники, коммерческий директор&nbsp;&mdash; лингвист и&nbsp;переводчик. Мы&nbsp;используем свой профессиональный опыт, чтобы предлагать наиболее надежные и&nbsp;эффективные технические решения для реализации мероприятий заказчика.',
        },
        {
            icon: WrenchIcon,
            title: 'Внимание к деталям',
            gradientDirection: 'bottom',
            description:
                'Закрываем глаза на&nbsp;формальности. Если нужно успеть отправить оборудование в&nbsp;другой город, чтобы не&nbsp;сорвать мероприятие, но&nbsp;оплата так и&nbsp;не&nbsp;поступила, мы&nbsp;отправляем его на&nbsp;доверии. И, кстати, еще ни&nbsp;разу не&nbsp;пожалели. Доверять&nbsp;&mdash; выгодно!',
        },
        {
            icon: StarIcon,
            title: 'Инновации и прогрессивность',
            gradientDirection: 'bottom-right',
            description:
                'Ежегодно посещаем крупнейшие отраслевые выставки ISE в&nbsp;Барселоне и&nbsp;Prolight &amp;&nbsp;Sound во&nbsp;Франкфурте&nbsp;&mdash; следим за&nbsp;последними тенденциями рынка, используем самые современные технологии и&nbsp;периодически обновляем парк оборудования.',
        },
        {
            icon: HeartIcon,
            title: 'Доверие',
            gradientDirection: 'left',
            description:
                'Cromi для нас&nbsp;&mdash; возможность реализовать весь инженерный и&nbsp;управленческий потенциал. Занимаемся только направлениями, в&nbsp;которых имеем 100% экспертность. В&nbsp;менеджменте балансируем между европейской чёткостью и&nbsp;русской душевностью.',
        },
    ],
    'radioguide.rent': [
        {
            icon: LogoIcon,
            title: 'Мы&nbsp;&mdash; фанаты<br />своего дела',
            gradientDirection: 'top-left',
            description: '',
        },
        {
            icon: GearIcon,
            title: 'Глубокая экспертность в&nbsp;сфере',
            gradientDirection: 'top-right',
            description:
                'Директор компании&nbsp;&mdash; дипломированный инженер аудио-визуальной техники, коммерческий директор&nbsp;&mdash; лингвист и&nbsp;переводчик. Мы&nbsp;используем свой профессиональный опыт, чтобы предлагать наиболее надежные и&nbsp;эффективные технические решения для реализации мероприятий заказчика.',
        },
        {
            icon: WrenchIcon,
            title: 'Внимание к&nbsp;деталям',
            gradientDirection: 'left',
            description:
                'Cromi для нас&nbsp;&mdash; возможность реализовать весь инженерный и&nbsp;управленческий потенциал. Занимаемся только направлениями, в&nbsp;которых имеем 100% экспертность. В&nbsp;менеджменте балансируем между европейской чёткостью и&nbsp;русской душевностью.',
        },
        {
            icon: StarIcon,
            title: 'Инновации и прогрессивность',
            gradientDirection: 'bottom-right',
            description:
                'Ежегодно посещаем крупнейшие отраслевые выставки ISE в&nbsp;Барселоне и&nbsp;Prolight &amp;&nbsp;Sound во&nbsp;Франкфурте&nbsp;&mdash; следим за&nbsp;последними тенденциями рынка, используем самые современные технологии и&nbsp;периодически обновляем парк оборудования.',
        },
        {
            icon: HeartIcon,
            title: 'Доверие',
            gradientDirection: 'bottom',
            description:
                'Закрываем глаза на&nbsp;формальности. Если нужно успеть отправить оборудование в&nbsp;другой город, чтобы не&nbsp;сорвать мероприятие, но&nbsp;оплата так и&nbsp;не&nbsp;поступила, мы&nbsp;отправляем его на&nbsp;доверии. И, кстати, еще ни&nbsp;разу не&nbsp;пожалели. Доверять&nbsp;&mdash; выгодно!',
        },
    ],
}

const isTablet = ref(false)

function checkIsDesktop() {
    if (!window) return

    isTablet.value = window.innerWidth >= 744

    if (window.innerWidth < 744) {
        new Swiper('.swiper-advantages', {
            slidesPerView: 'auto',
            spaceBetween: 8,
            breakpoints: {
                440: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                },
            },
        })
    }
}

onMounted(() => {
    checkIsDesktop()
    window.addEventListener('resize', checkIsDesktop)
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkIsDesktop)
})
</script>
